import { inject, observer } from 'mobx-react';
import s from './index.module.scss';
import withRouter from '@/components/withRouter';
import { Outlet } from 'react-router-dom';
import SimulationHeader from './Pages/components/Header/Header';
import ReStartModal from './Pages/components/Modal/ReStartModal';
import { Display } from '@/components/Display/Display';
import NoAuth from '@/components/Web/NoAuth';
import { caseCodeMap } from '@/utils/contants/caseSimulation';
import Error from '@/components/Web/Error';
import agentErrImg from '@/assets/images/mobile/agent_error.png';
import GrtLoading from '@/components/Web/GrtLoading';
import useCaseEntry from '@/pages/hooks/CaseSImulation/useCaseEntry';
const Simulation = (props) => {
    let { simulation, grtAi } = props.store;
    const { currentAgent = {}, agentLoading } = grtAi.state;
    let { closeGuideModal, errorCode } = simulation;
    const { reStartCase, loading } = useCaseEntry({ side: 'web', ...props });

    return (
        <>
            <Display show={agentLoading}>
                <GrtLoading spinning={true}></GrtLoading>
            </Display>
            <Display show={!agentLoading}>
                <Display show={currentAgent.error}>
                    <Error text={currentAgent?.error} img={agentErrImg}></Error>
                </Display>
                <Display show={!currentAgent.error}>
                    <div className={s['simulation-box']}>
                        {/* 放到header里盖不住内容区域 */}
                        <ReStartModal
                            loading={loading}
                            show={simulation.guideModalShow.restart}
                            onClose={closeGuideModal}
                            onConfirm={reStartCase}
                        ></ReStartModal>
                        <SimulationHeader></SimulationHeader>
                        <div className={s['simulation-content-wrap']}>
                            <div className={s['simulation-content']}>
                                <Display show={errorCode === caseCodeMap.noAuth}>
                                    <NoAuth text="该场景由其他用户创建，您无权查看"></NoAuth>
                                </Display>

                                <Display show={errorCode !== caseCodeMap.noAuth && !loading}>
                                    <Outlet />
                                </Display>
                            </div>
                        </div>
                    </div>
                </Display>
            </Display>
        </>
    );
};

export default withRouter(inject('store')(observer(Simulation)));
